import React from 'react';
import '../../Custom UI/common.scss'
import moment from 'moment-timezone'
import 'antd/dist/antd.css'
import {Translation} from "react-i18next";
import i18next from "i18next";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import './SurveyResponses.scss';
import InfiniteScroll from "react-infinite-scroll-component";
import SurveyResponseCell from "../../Cells/SurveyResponseCell/SurveyResponseCell";
import InfiniteScrollManager from "../../managers/InfiniteScrollManager";
import Loading from "../../Custom UI/Loading/Loading";
import {SurveyLockedState} from "../../actions/surveyActions";
import CloseIcon from '@material-ui/icons/Close';
import {roleForCompany} from "../../Helpers/CompanyHelpers";
import {currentDateHumanizedWithoutTimeStamp} from "../../Helpers/DateHelpers";
import fileDownload from "js-file-download";
import {toast} from "react-toastify";
import {NOTIFY_OPTS} from "../../constants/Notifiers";
import SurveyResponseModal from "../../Modals/SurveyResponseModal/SurveyResponseModal";
import ConfirmationModal from "../../Modals/ConfirmationModal/ConfirmationModal";
import LabeledSwitch from "../../Custom UI/LabeledInputs/LabeledSwitch/LabeledSwitch";
import {errorMessageFromServerError} from "../../Helpers/Helpers";

const notifySurveyResponseDeleteOrRestoreSuccess = (aIsRestore) => toast(i18next.t(aIsRestore ? 'RESTORE_SURVEY_RESPONSE_SUCCESS' : 'DELETE_SURVEY_RESPONSE_SUCCESS'), NOTIFY_OPTS.autoClose);
const notifySurveyResponseDeleteOrRestoreError = (aIsRestore, aError) => toast(i18next.t(aIsRestore ? 'RESTORE_SURVEY_RESPONSE_ERROR' : 'DELETE_SURVEY_RESPONSE_ERROR', {aError}), NOTIFY_OPTS.autoClose);

const notifyDownloadGenerated = () => toast(<Translation>{ (t, { i18n }) => t('REPORT_SENT_TO_ADMIN_EMAIL') }</Translation>, NOTIFY_OPTS.autoCloseFiveSeconds);

export default class SurveyResponses extends React.Component {
  
  // Instance Variables
  
  scrollManager = new InfiniteScrollManager({
    getItems: (offset, limit) => this.getSurveyResponses(limit, offset),
    success: () => this.updateList(),
    fail: (error) => console.error('SurveyResponses (InfiniteScrollManager): Failed with error:', error)
  });
  
  // Init
  
  constructor(props){
    super(props);
    this.state = {
      menuAnchorElement:null,
      surveyResponsesArray:[],
      totalSurveyResponses:0,
      selectedSurveyResponse:null,
      historySurveyResponse:null,
      surveyResponseModalOpen:false,
      responseConfirmationModalOpen:false,
      saving:false,
      includeDeleted:['admin', 'admin_level_3', 'admin_level_4'].includes(roleForCompany(props.company)),
    };
    this.closeMenu = this.closeMenu.bind(this);
    this.downloadReport = this.downloadReport.bind(this);
    this.lockSurveyResponse = this.lockSurveyResponse.bind(this);
    this.emailReportToPatient = this.emailReportToPatient.bind(this);
  }
  
  componentDidMount(){
    this.scrollManager.fetch(true);
  }
  
  componentDidUpdate(prevProps, prevState, snapshot){
    if(prevProps.surveyId !== this.props.surveyId){
      this.setState({ surveyResponsesArray:[], totalSurveyResponses:0, menuAnchorElement:null, selectedSurveyResponse:null,
        includeDeleted:['admin', 'admin_level_3', 'admin_level_4'].includes(roleForCompany(this.props.company))});
      this.scrollManager.fetch(true);
    }
    else if(prevProps.patientId !== this.props.patientId){
      this.setState({ surveyResponsesArray:[], totalSurveyResponses:0, menuAnchorElement:null, selectedSurveyResponse:null});
      this.scrollManager.fetch(true);
    }
    else if(prevProps.company !== this.props.company){
      this.setState({ surveyResponsesArray:[], totalSurveyResponses:0, menuAnchorElement:null, selectedSurveyResponse:null,
        includeDeleted:['admin', 'admin_level_3', 'admin_level_4'].includes(roleForCompany(this.props.company))});
      this.scrollManager.fetch(true);
    }
  }
  
  // Methods
  
  updateList(){
    this.setState({surveyResponsesArray:this.scrollManager.getList()});
  }
  
  getSurveyResponses(limit, offset){
    const includeDeleted = ['admin', 'admin_level_3', 'admin_level_4'].includes(roleForCompany(this.props.company)) && this.state.includeDeleted;
    return this.props.getSurveyResponses(this.props.patientId, Number(this.props.surveyId), limit, offset, includeDeleted).then((newResponse) => {
      let data = newResponse.data.data.survey_response_page;
      let surveyResponsesArray = data.survey_responses;
      let totalSurveyResponses = data.total;
      this.setState({totalSurveyResponses:totalSurveyResponses});
      return {objects:surveyResponsesArray, total:totalSurveyResponses};
    });
  }
  
  static formattedDateTime(timestamp){
    const timeZone = moment.tz.guess();
    return moment(timestamp, 'YYYY-MM-DD HH:mm:ss Z').tz(timeZone || 'America/New_York').format('L') + ' @ ' + moment(timestamp, 'YYYY-MM-DD HH:mm:ss Z').tz(timeZone || 'America/New_York').format('LT z')
  }
  
  lockSurveyResponse(aSurveyResponse){
    this.props.updateSurveyResponseLockState(aSurveyResponse.id, SurveyLockedState.Locked).then(result => {
      aSurveyResponse.lock_state = result.data.data.updateSurveyResponseLockState.survey_response.lock_state;
      this.props.fetchPatient({ userId: this.props.patient.id })
    });
    this.setState({menuAnchorElement:null, selectedSurvey:null});
  };
  
  downloadReport(aSurveyResponse){
    const reportReqParams = {
      company_id: this.props.company.id,
      user_id: this.props.patientId,
      survey_response_id: aSurveyResponse.id
    };
    global.api.post("/api/tool_stats/patient_survey_report_pdf", reportReqParams, {responseType: 'blob'})
    .then((result) => {
      let fileName = `survey_response_${currentDateHumanizedWithoutTimeStamp()}.pdf`;
      //   notifyReportGenerationSuccess(fileName, tabIndex);
      fileDownload(result.data, fileName, 'application/pdf');
    })
  }
  
  emailReportToPatient(aSurveyResponse){
    const reportReqParams = {
      company_id: this.props.company.id,
      user_id: this.props.patientId,
      survey_response_id: aSurveyResponse.id
    };
    global.api.post("/api/tool_stats/send_patient_survey_report_pdf", reportReqParams, {responseType: 'blob'})
    .then((result) => {
      notifyDownloadGenerated();
    })
  }
  
  closeMenu(){
    this.setState({menuAnchorElement:null});
  }

  changeIncludeDeleted(includeDeleted){
    this.setState({includeDeleted, surveyResponsesArray:[], totalSurveyResponses:0}, () => this.scrollManager.fetch(true));
  }

  reloadSurveyResponses = () => {
    this.setState({surveyResponsesArray:[], totalSurveyResponses:0}, () => this.scrollManager.fetch(true));
  };

  surveyResponseDeleteOrRestore(aSurveyResponse){
    const isDeleted = aSurveyResponse && aSurveyResponse.deleted_at;
    const action = isDeleted ? this.props.restoreSurveyResponse : this.props.deleteSurveyResponse;

    this.setState({saving:true});
    action(aSurveyResponse.id, this.props.company.id).then(() => {
      notifySurveyResponseDeleteOrRestoreSuccess(Boolean(isDeleted));
      this.setState({saving:false, menuAnchorElement:null, selectedSurveyResponse:null, responseConfirmationModalOpen:false, surveyResponsesArray:[], totalSurveyResponses:0}, () => this.scrollManager.fetch(true));
    }, (newError) => {
      this.setState({saving:false});
      notifySurveyResponseDeleteOrRestoreError(Boolean(isDeleted), errorMessageFromServerError(newError));
    });
  }

  closeSurveyResponseModal(){
    this.setState({surveyResponseModalOpen:false, historySurveyResponse:null, selectedSurveyResponse:null});
  }
  
  // Render
  
  render() {
    const { title, height, company, onCloseDrawer, selectSurveyResponse, showLockOption = true,
      userName, patient, user, createDataQueryNote, getDataQueryNotes, getDataQueryNoteComments, resolveDataQueryNote, createDataQueryComment,
      fetchQuestionsForSurveyByReference, getSurveyResponseDetails, getAdminHistories, addDataQuery,
      deleteSurveyResponse, restoreSurveyResponse, deleteSurveyResponseDetail, restoreSurveyResponseDetail } = this.props;
    const { menuAnchorElement, totalSurveyResponses, surveyResponsesArray, selectedSurveyResponse,
      historySurveyResponse, surveyResponseModalOpen, responseConfirmationModalOpen, includeDeleted, saving } = this.state;
    
    const surveyResponsesProhibitions = ['admin_level_8'];
    const currentRole = roleForCompany(company);
    const canDeleteRestore = ['admin', 'admin_level_3', 'admin_level_4'].includes(currentRole);
    
    return (
      <div className="survey-response-container">
        {!surveyResponsesProhibitions.includes(currentRole) ?
          <div>
            <div className="survey-list-title">
              <div>
                <div>
                  <b>{title}</b>
                </div>
                <Translation>{(t, {i18n}) => t('SURVEY_RESPONSES')}</Translation> - {totalSurveyResponses}
              </div>
              {canDeleteRestore ?
                <LabeledSwitch className="survey-response-include-deleted"
                               label={i18next.t('INCLUDE_DELETED')}
                               checked={includeDeleted}
                               onChange={(includeDeleted) => this.changeIncludeDeleted(includeDeleted)}
                               showCheckedLabels={false}
                               switchPosition={'bottom'}
                />
                : null
              }
              <CloseIcon onClick={onCloseDrawer} />
            </div>
            
            <div id="payments-list"
                 className="survey-response-cell-list-container"
                 style={{height: height ? height : '100vh - 275px'}}>
              <InfiniteScroll style={{overflowY: "hidden"}}
                              next={() => this.scrollManager.fetch(false)}
                              loader={<Loading loading={this.scrollManager.isLoading()}/>}
                              hasMore={!this.scrollManager.hasLoadedAll()}
                              dataLength={() => this.scrollManager.length()}
                              scrollableTarget="payments-list">
                
                {surveyResponsesArray && surveyResponsesArray.length > 0 ?
                  <div>
                    {surveyResponsesArray.map((surveyResponse, index) => (
                      <SurveyResponseCell key={surveyResponse.id + index}
                                          onClick={() => selectSurveyResponse(surveyResponse)}
                                          surveyResponse={surveyResponse}
                                          menuButtonClicked={(aEvent) => this.setState({menuAnchorElement:aEvent.currentTarget, selectedSurveyResponse:surveyResponse})}
                      />
                    ))}
                  </div>
                  :
                  <div className="no-information-text">
                    <Translation>{ (t, { i18n }) => t('NO_SURVEY_RESPONSES')}</Translation>
                  </div>
                }
              </InfiniteScroll>
            </div>
            
            <Menu id="survey-responses-menu"
                  open={Boolean(menuAnchorElement)}
                  style={{zIndex:99999}}
                  onClose={() => {this.closeMenu()}}
                  anchorEl={menuAnchorElement}
                  keepMounted>
              <MenuItem style={{position:'relative'}}
                        onClick={() => {
                          this.setState({menuAnchorElement:null,
                            historySurveyResponse:selectedSurveyResponse,
                            surveyResponseModalOpen:true});
                        }}>
                <Translation>{ (t, { i18n }) => t('VIEW_HISTORY')}</Translation>
              </MenuItem>

              {selectedSurveyResponse && canDeleteRestore ?
                <MenuItem style={{position:'relative'}}
                          onClick={() => this.setState({menuAnchorElement:null, responseConfirmationModalOpen:true})}>
                  {i18next.t(selectedSurveyResponse.deleted_at ? 'RESTORE' : 'DELETE')}
                </MenuItem>
                :
                null
              }

              {showLockOption && selectedSurveyResponse && selectedSurveyResponse.lock_state !== SurveyLockedState.Locked ?
                <MenuItem style={{position:'relative'}}
                          onClick={() => {
                            this.lockSurvey(selectedSurveyResponse);
                            this.closeMenu();
                          }}>
                  <Translation>{ (t, { i18n }) => t('LOCK')}</Translation>
                </MenuItem>
                :
                null
              }
              
              <MenuItem style={{position:'relative'}}
                        onClick={() => {
                          this.downloadReport(selectedSurveyResponse);
                          this.closeMenu();
                        }}>
                <Translation>{ (t, { i18n }) => t('DOWNLOAD_REPORT')}</Translation>
              </MenuItem>
              
              <MenuItem style={{position:'relative'}}
                        onClick={() => {
                          this.emailReportToPatient(selectedSurveyResponse);
                          this.closeMenu();
                        }}>
                <Translation>{ (t, { i18n }) => t('EMAIL_REPORT_TO_PATIENT')}</Translation>
              </MenuItem>
            </Menu>

            <ConfirmationModal title={i18next.t(selectedSurveyResponse && selectedSurveyResponse.deleted_at ? 'RESTORE_SURVEY_RESPONSE' : 'DELETE_SURVEY_RESPONSE')}
                               description={i18next.t(selectedSurveyResponse && selectedSurveyResponse.deleted_at ? 'RESTORE_SURVEY_RESPONSE_CONFIRMATION' : 'DELETE_SURVEY_RESPONSE_CONFIRMATION')}
                               isOpen={responseConfirmationModalOpen}
                               reject={() => this.setState({responseConfirmationModalOpen:false})}
                               confirm={() => this.surveyResponseDeleteOrRestore(selectedSurveyResponse)}
                               loading={saving}
                               presentedInsideParentModal={true}
            />

            <SurveyResponseModal open={surveyResponseModalOpen}
                                 close={() => this.closeSurveyResponseModal()}
                                 company={company}
                                 surveyResponseId={historySurveyResponse && historySurveyResponse.id}
                                 userName={userName}
                                 title={title}
                                 lockedState={historySurveyResponse && historySurveyResponse.lock_state}
                                 surveyResponse={historySurveyResponse}
                                 patient={patient}
                                 user={user}
                                 createDataQueryNote={createDataQueryNote}
                                 getDataQueryNotes={getDataQueryNotes}
                                 getDataQueryNoteComments={getDataQueryNoteComments}
                                 resolveDataQueryNote={resolveDataQueryNote}
                                 createDataQueryComment={createDataQueryComment}
                                 surveyReference={historySurveyResponse && historySurveyResponse.survey && historySurveyResponse.survey.reference}
                                 fetchQuestionsForSurveyByReference={fetchQuestionsForSurveyByReference}
                                 getSurveyResponseDetails={getSurveyResponseDetails}
                                 getAdminHistories={getAdminHistories}
                                 addDataQuery={addDataQuery}
                                 deleteSurveyResponse={deleteSurveyResponse}
                                 restoreSurveyResponse={restoreSurveyResponse}
                                 deleteSurveyResponseDetail={deleteSurveyResponseDetail}
                                 restoreSurveyResponseDetail={restoreSurveyResponseDetail}
                                 reloadSurveyResponses={this.reloadSurveyResponses}
            />
          </div>
          :
          <div className="no-information-text">
            <Translation>{ (t, { i18n }) => t('NO_ADMIN_PERMISSION')}</Translation>
          </div>
        }
      </div>
    )
  }
}
